import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { VerifyTwoFactorComponent } from './components/login/verify-two-factor/verify-two-factor.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';
import { OrganizationsComponent } from './components/organizations/organizations.component';
import { PricingPlansComponent } from './components/pricing-plans/pricing-plans.component';
import { SessionsComponent } from './components/sessions/sessions.component';
import { SessionDetailComponent } from './components/sessions/detail/session-detail.component';
import { LlmComponent } from './components/llm/llm.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { PracticeCoursesComponent } from './components/practice-courses/practice-courses.component';
import { PracticeCourseDetailComponent } from './components/practice-courses/detail/practice-course-detail.component';
import { PracticeCourseRepComponent } from './components/practice-courses/rep/practice-course-rep.component';
import { authGuard } from './guards/auth.guard';
import { guestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [guestGuard],
  },
  {
    path: 'login/verify-2fa',
    component: VerifyTwoFactorComponent,
    canActivate: [guestGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'organizations', component: OrganizationsComponent },
      {
        path: 'users',
        loadComponent: () =>
          import('./components/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'organizations/:orgId',
        loadComponent: () =>
          import('./components/organizations/detail/org-detail.component').then(
            (m) => m.OrgDetailComponent,
          ),
      },
      { path: 'pricing-plans', component: PricingPlansComponent },
      {
        path: 'sessions',
        children: [
          { path: '', component: SessionsComponent },
          { path: ':type/:sessionId', component: SessionDetailComponent },
        ],
      },
      { path: 'llm', component: LlmComponent },
      {
        path: 'research',
        loadComponent: () =>
          import('./components/research/research.component').then((m) => m.ResearchComponent),
      },
      { path: 'feedback', component: FeedbackComponent },
      {
        path: 'support-tickets',
        loadComponent: () =>
          import('./components/support-tickets/support-tickets.component').then(
            (m) => m.SupportTicketsComponent,
          ),
      },
      {
        path: 'waitlist',
        loadComponent: () =>
          import('./components/waitlist/waitlist.component').then((m) => m.WaitlistComponent),
      },
      {
        path: 'tracking',
        loadComponent: () =>
          import('./components/tracking/tracking.component').then((m) => m.TrackingComponent),
      },
      {
        path: 'tracking/affiliates/:id',
        loadComponent: () =>
          import('./components/tracking/affiliate-detail.component').then(
            (m) => m.AffiliateDetailComponent,
          ),
      },
      {
        path: 'practice-courses',
        children: [
          { path: '', component: PracticeCoursesComponent },
          { path: ':courseVersionId/reps/:userId', component: PracticeCourseRepComponent },
          { path: ':courseVersionId', component: PracticeCourseDetailComponent },
        ],
      },
      {
        path: 'api-docs',
        loadComponent: () =>
          import('./components/api-docs/api-docs.component').then((m) => m.ApiDocsComponent),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
